export default __webpack_public_path__ + "static/char-v-09-a9c3ccb915a835b114be54be9c88059f.webp";